import React from 'react'
import { makeStyles } from '@paintscout/ui'
import type { MuiTheme as Theme } from '@paintscout/ui'
import ProfileButton from 'src/components/common/ProfileButton'

const useStyles = makeStyles((theme: Theme) => {
  const linkColor = theme.palette.secondary.contrastText
  return {
    root: {
      display: 'flex',
      alignItems: 'center',
      color: linkColor
    },
    profileButton: {
      paddingLeft: theme.typography.pxToRem(8),
      color: theme.palette.secondary.contrastText
    }
  }
})

export interface UserButtonsProps {
  classes?: Partial<ReturnType<typeof useStyles>>
}

export default function UserButtons(props: UserButtonsProps) {
  const defaultClasses = useStyles()
  const classes = { ...defaultClasses, ...props.classes }

  return (
    <div className={classes.root}>
      <ProfileButton
        classes={{
          root: classes.profileButton
        }}
      />
    </div>
  )
}
